import React from 'react';
import WebsiteLayout from '../components/layouts/WebsiteLayout';
import { AboutUs } from '../components/website/AboutUs';

const AboutUsPage: React.FC = () => {
  return (
    <WebsiteLayout>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '2rem 1rem'
      }}>
        <AboutUs />
      </div>
    </WebsiteLayout>
  );
};

export default AboutUsPage;
